import I18n from 'I18n';
import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { trackClickedLink } from '../../../../utils/tracking/trackingEventUtils';
export const useHandleClickFreeToolsWithLimitsLink = () => {
  const history = useHistory();
  return useCallback(() => {
    trackClickedLink({
      name: 'business-objective-link',
      value: I18n.text('pricing-pages-ui.merchCardsV2.priorityFeatures.freeToolsWithLimits', {
        locale: 'en-us'
      }),
      type: 'internal',
      url: '/crm',
      trackingSource: 'merch-card'
    });
    history.push('/crm');
  }, [history]);
};